import script from "./StripeGateway.vue?vue&type=script&setup=true&lang=js"
export * from "./StripeGateway.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__